import {Box} from "@mui/material";

import ResponsiveAppBar from "../assets/components/ResponsiveAppBar.tsx";
import Footer from "./Footer.tsx";
import TermsOfService from "../assets/components/TermsOfService.tsx";

function Privacy() {
    return (
        <>
            <Box sx={{}}>
                <ResponsiveAppBar/>
                <TermsOfService/>
                <Footer/>
            </Box>
        </>
    );
}

export default Privacy
